module.exports = __webpack_public_path__ + "media/images/home/fausto_btc-b04ccb076d3d83c810d1cff21ff23627.png";